
import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        isNeedCar: {
            type: Boolean,
            default: false,
        },
        companyName: {
            type: String,
            default: null,
        },
        userName: {
            type: String,
            default: null,
        },
        logistName: {
            type: String,
            default: null,
        },
        takeDate: {
            type: String,
            default: null,
        },
        takeTime: {
            type: String,
            default: null,
        },
        ftlTypeName: {
            type: String,
            default: null,
        },
        managerName: {
            type: String,
            default: null,
        },
        shipmentTypeName: {
            type: String,
            default: null,
        },
    },
})
